import { ProgressBar, Modal } from "react-bootstrap";
import Styles from "./style.module.css";
export const ProgressModal = ({ current, total, show, label }) => {
    const progression = Math.round(current === 0 ? 0 : ((current * 100) / total));
    return (
        <Modal backdropClassName={Styles['modal-backdrop']} className={Styles['content-center-modal']} show={show} size="lg">
            <ProgressBar now={progression} label={label} />
        </Modal>
    );
};